import { render, staticRenderFns } from "./PermissionsFilter.vue?vue&type=template&id=75c88df4&scoped=true&"
import script from "./PermissionsFilter.vue?vue&type=script&lang=js&"
export * from "./PermissionsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c88df4",
  null
  
)

export default component.exports